import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Su from "./pages/Su";
import Home from "./pages/Home";
import StudentPlay from "./pages/StudentPlay";

export const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <div>
        <RouterRoutes>
          <Route path='/' element={<Home />} />
          <Route path='/play' element={<StudentPlay />} />
          <Route path='/login' element={<Login />} />
          <Route path='/su/*' element={<Su />} />
        </RouterRoutes>
      </div>
    </BrowserRouter>
  );
};
